import React from 'react';
import { Link } from 'react-router-dom';
import { BookOpen, Calendar, CheckCircle, TrendingUp } from 'lucide-react';

const Vysledky = () => {
  const resultsPersonaA = [
    {
      id: 1,
      quote: 'Prvykrat po rokoch viem, co vlastne s mojimi peniazmi je.',
      name: 'M. K.',
      role: 'podnikatel',
      age: 42,
      before: ['mal 5 roznych investicii', 'ziadnu strategiu', 'vysoky stres pri rozhodovani'],
      after: ['kompletny prehlad majetku', 'zjednotenie investicii', 'jasna rentova strategia', 'pokoj v rozhodovani']
    },
    {
      id: 2,
      quote: 'Upratal mi majetok tak, ze viem, co mozem cakat najblizsich 20 rokov.',
      name: 'J. H.',
      role: 'manazer',
      age: 38,
      before: ['chaoticke investicie', 'nahodne rozhodnutia', 'tlak, ze "mal by nieco robit"'],
      after: ['struktura majetku', 'realisticky investicny plan', 'zmysluplne kroky na 12-24 mesiacov', 'dlhodoby pokoj']
    },
    {
      id: 3,
      quote: 'Konecne mam strategiu, ktora prezije aj krizu.',
      name: 'L. S.',
      role: 'podnikatel',
      age: 45,
      before: ['vysoke rizika', 'impulzivne rozhodnutia'],
      after: ['stabilna strategia', 'vhodne rozlozenie rizik', 'priebezna kontrola portfólia']
    }
  ];

  const resultsPersonaB = [
    {
      id: 4,
      quote: 'Vdaka Petovi som prestal byt produktovy poradca.',
      name: 'L. P.',
      role: 'VR/M',
      age: 34,
      before: ['citil tlak na predaj', 'nerastol', 'nemal system'],
      after: ['prechod na wealth manazment', 'stabilne AUM', 'silna osobna znacka', 'lepsi klienti']
    },
    {
      id: 5,
      quote: 'Nikdy som nechcel predavat produkty. Dnes robim poradenstvo, ktore ma zmysel.',
      name: 'R. S.',
      role: 'poradca',
      age: 29,
      before: [],
      after: ['system renty a majetku', 'profesionalny mentoring', 'vyssia produkcia bez tlaku', 'skutocne vztahy s klientmi']
    },
    {
      id: 6,
      quote: 'Zacal som robit poradenstvo tak, ako som vzdy chcel.',
      name: 'M. T.',
      role: 'poradca',
      age: 31,
      before: [],
      after: ['prechod zo starej struktury', 'praca v timovom systeme', 'vacsi pokoj, menej stresu', 'liderstvo']
    }
  ];

  const systemPoints = [
    'majetkoveho poriadku',
    'moderneho investovania',
    'rentoveho myslenia',
    'dlhodobej discipliny',
    'partnerstva bez natlaku'
  ];

  return (
    <div className="vysledky-page overflow-x-clip">
      {/* 1. HERO SEKCIA */}
      <section className="relative bg-brand-dark-blue text-white min-h-[70vh] flex items-center overflow-x-clip">
        <div 
          className="absolute inset-0 opacity-10"
          style={{
            backgroundImage: 'url(/symbol-3.svg)',
            backgroundSize: '400px 400px',
            backgroundRepeat: 'repeat'
          }}
        />

        <div className="container mx-auto px-4 sm:px-5 relative z-10 max-w-full min-w-0">
          <div className="max-w-4xl mx-auto text-center min-w-0 px-1">
            <h1 className="text-2xl min-[400px]:text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-heading font-bold mb-8 text-white leading-tight break-words">
              Skutocne pribehy ludi, ktorym som pomohol.
            </h1>
            
            <p className="text-base sm:text-xl lg:text-2xl text-gray-300 leading-relaxed">
              Vysledky hovoria viac nez marketing.<br/>
              Tu su pribehy podnikatelov, manazerov a poradcov, ktori chceli poriadok v majetku 
              alebo karieru, ktora dava zmysel.
            </p>
          </div>
        </div>
      </section>

      {/* 2. PERSONA A - INVESTICIE, MAJETOK, RENTA */}
      <section className="section bg-gray-100">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-4xl lg:text-5xl font-heading font-bold mb-6 text-brand-dark-blue">
              Vysledky pre ludi, ktori chcu pokoj v majetku
            </h2>
            <p className="text-lg text-gray-600">
              (toto nie su vymyslene marketingove slogany - ale realne transformacie)
            </p>
          </div>

          <div className="max-w-5xl mx-auto space-y-12">
            {resultsPersonaA.map((result) => (
              <div 
                key={result.id}
                className="bg-white rounded-3xl p-10 lg:p-12 shadow-xl"
              >
                <p className="text-2xl lg:text-3xl font-semibold text-brand-dark-blue mb-6 italic leading-relaxed">
                  "{result.quote}"
                </p>
                
                <div className="flex items-center gap-4 mb-8 pb-6 border-b border-gray-200">
                  <div className="bg-brand-orange w-16 h-16 rounded-full flex items-center justify-center text-white font-bold text-xl">
                    {result.name.split('.')[0]}
                  </div>
                  <div>
                    <p className="font-bold text-lg text-brand-dark-blue">{result.name}</p>
                    <p className="text-gray-600">{result.role} ({result.age})</p>
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                  {result.before.length > 0 && (
                    <div>
                      <h4 className="text-lg font-bold text-gray-500 mb-4">PRED:</h4>
                      <ul className="space-y-2">
                        {result.before.map((item, idx) => (
                          <li key={idx} className="text-gray-600 flex items-start">
                            <span className="text-red-500 mr-2">×</span>
                            <span>{item}</span>
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                  
                  <div>
                    <h4 className="text-lg font-bold text-brand-dark-blue mb-4">VYSLEDOK:</h4>
                    <ul className="space-y-2">
                      {result.after.map((item, idx) => (
                        <li key={idx} className="text-gray-700 flex items-start">
                          <CheckCircle size={20} className="text-brand-orange mr-2 mt-1 flex-shrink-0" />
                          <span>{item}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 3. PERSONA B - KARIERA, LEADERSHIP */}
      <section className="section bg-brand-dark-blue text-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-4xl lg:text-5xl font-heading font-bold mb-6">
              Vysledky poradcov, ktori presli na moderny wealth manazment
            </h2>
          </div>

          <div className="max-w-5xl mx-auto space-y-12">
            {resultsPersonaB.map((result) => (
              <div 
                key={result.id}
                className="bg-white bg-opacity-10 backdrop-blur-sm rounded-3xl p-10 lg:p-12"
              >
                <p className="text-2xl lg:text-3xl font-semibold text-white mb-6 italic leading-relaxed">
                  "{result.quote}"
                </p>
                
                <div className="flex items-center gap-4 mb-8 pb-6 border-b border-gray-600">
                  <div className="bg-brand-orange w-16 h-16 rounded-full flex items-center justify-center text-white font-bold text-xl">
                    {result.name.split('.')[0]}
                  </div>
                  <div>
                    <p className="font-bold text-lg text-white">{result.name}</p>
                    <p className="text-gray-400">{result.role} ({result.age})</p>
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                  {result.before.length > 0 && (
                    <div>
                      <h4 className="text-lg font-bold text-gray-400 mb-4">PRED:</h4>
                      <ul className="space-y-2">
                        {result.before.map((item, idx) => (
                          <li key={idx} className="text-gray-400 flex items-start">
                            <span className="text-red-400 mr-2">×</span>
                            <span>{item}</span>
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                  
                  <div>
                    <h4 className="text-lg font-bold text-brand-light-orange mb-4">VYSLEDOK:</h4>
                    <ul className="space-y-2">
                      {result.after.map((item, idx) => (
                        <li key={idx} className="text-gray-300 flex items-start">
                          <CheckCircle size={20} className="text-brand-orange mr-2 mt-1 flex-shrink-0" />
                          <span>{item}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 4. CO MA SPAJA S VYSLEDKAMI */}
      <section className="section bg-gray-100">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-4xl lg:text-5xl font-heading font-bold mb-12 text-center text-brand-dark-blue">
              Nie zazraky. System.
            </h2>
            
            <div className="bg-white rounded-3xl p-10 lg:p-16 shadow-xl">
              <div className="space-y-6 text-xl text-gray-700 leading-relaxed">
                <p>
                  Moji klienti neuspeju preto, ze maju stastie.
                </p>
                
                <p className="text-2xl font-semibold text-brand-dark-blue">
                  Uspeju preto, ze vyuzivaju system:
                </p>
                
                <ul className="space-y-4 my-8">
                  {systemPoints.map((point, index) => (
                    <li key={index} className="flex items-start text-lg">
                      <CheckCircle size={24} className="text-brand-orange mr-4 mt-1 flex-shrink-0" />
                      <span>{point}</span>
                    </li>
                  ))}
                </ul>
                
                <p className="text-xl font-semibold text-brand-dark-blue text-center py-6 border-t border-gray-200">
                  Tieto hodnoty presne popisujem v knihe Renta bez datumu spotreby.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 5. ZAVERECNE CTA */}
      <section className="section relative bg-brand-dark-blue text-white overflow-hidden">
        <div 
          className="absolute inset-0 opacity-5"
          style={{
            backgroundImage: 'url(/symbol-3.svg)',
            backgroundSize: '300px 300px',
            backgroundRepeat: 'repeat'
          }}
        />

        <div className="container mx-auto px-4 relative z-10">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-4xl lg:text-6xl font-heading font-bold mb-8">
              Chcete patrit k ludom, ktori v majetku nasli pokoj?
            </h2>
            <p className="text-2xl text-gray-300 mb-12 leading-relaxed">
              Zacznite jednou kratkou konzultaciou alebo si precitajte moju knihu.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-6 justify-center">
              <Link 
                to="/kniha"
                className="inline-flex items-center sm:whitespace-nowrap sm:shrink-0 bg-gradient-to-r from-brand-orange to-red-500 hover:from-red-500 hover:to-brand-orange text-white font-bold py-5 px-10 rounded-xl transition-all duration-300 transform hover:scale-105 hover:shadow-2xl text-lg"
              >
                <BookOpen size={24} className="mr-3" />
                Kniha: Renta bez datumu spotreby
              </Link>
              <Link 
                to="/konzultace"
                className="inline-flex items-center sm:whitespace-nowrap sm:shrink-0 bg-white bg-opacity-10 hover:bg-opacity-20 backdrop-blur-sm border-2 border-white text-white font-bold py-5 px-10 rounded-xl transition-all duration-300 transform hover:scale-105 text-lg"
              >
                <Calendar size={24} className="mr-3" />
                Zarezervovat konzultaciu
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Vysledky;
